export interface NetworkInfo {
  id: string;
  name: string;
  type: NetworkInfoDetailsType;
  details?: LanNetworkInfoDetails | WifiNetworkInfoDetails | CellNetworkInfoDetails;
  is_enabled: boolean;
  ipv4?: string;
  ipv6?: string;
  mac?: string;
}

export enum NetworkInfoDetailsType {
  lan = 1,
  wifi = 2,
  cell = 3,
}

export interface LanNetworkInfoDetails {
  link_speed_mbps?: number;
  duplex?: LanDuplexMode;
}

export enum LanDuplexMode {
  half = 1,
  full = 2,
}

export interface WifiNetworkInfoDetails {
  ssid?: string;
  bssid?: string;
  security?: WifiSecurity;
}

export enum WifiSecurity {
  unknown = 1,
  open = 2,
  wep = 3,
  wpa = 4,
  wpa2 = 5,
  wpa3 = 6,
}

export interface CellNetworkInfoDetails {
  carrier?: string;
  network_type?: CellNetworkType;
  apn?: string;
  is_roaming?: boolean;
  imei?: string;
  iccid?: string;
}

export enum CellNetworkType {
  unknown = 1,
  gen2 = 2,
  gen3 = 3,
  gen4 = 4,
  gen5 = 5,
}
